import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addpaytype',
  templateUrl: './addpaytype.component.html',
  styleUrls: ['./addpaytype.component.css']
})
export class AddpaytypeComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: String = "PayType";
  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  paytypeColl: any = [];
  paytypeBO: any = {};

  paytypeid: number = 0

  paytypeform = new FormGroup({
    paytypeid: new FormControl(0),
    paytypename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.paytypeid = params.id
      }
    });

    this.fnServiceChanges();
  }



  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }


    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.paytypeform.reset();
      this.fnInitializeFormGroup();

      if (this.paytypeid > 0) {
        this.fngetPayType();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.paytypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnInitializeFormGroup() {
    this.paytypeform.setValue({
      paytypeid: 0,
      paytypename: '',
      inactive: false
    })
  }

  //Get 
  fngetPayType() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();

    var data = {
      'paytypeid': this.paytypeid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getPayType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();
            this.paytypeColl = res.json().result;
            var editdata = this.paytypeColl[0];
            this.fnEditMode(editdata);
            this.paytypeBO=editdata;
          }
          else {
            this.fnHideProgress();
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {if (this.saveloading) {
      return;
    }

      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.paytypeform.valid) { this.saveloading = true;
        //Check
        var data = {
          'paytypeid': this.paytypeid,
          'paytypename': this.paytypeform.get('paytypename').value,
          'inactive': this.paytypeform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckPayType(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.paytypeform.get('paytypeid').value > 0) {
                  //Update 
                  this.fnSetpaytype(data);
                }
                else {
                  //Insert 
                  this.fnInsertpaytype(data);
                }
              }
              else {
                if (_checkresult === "name") { this.saveloading = false;

                  this.paytypeform.controls['paytypename'].setErrors({ 'notfound': true });
                }
              }
            }
            else { this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => { this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) { this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertpaytype(data) {

    this.appService.fnInsertPayType(data).subscribe(
      (res) => { this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new paytype has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.paytypeename);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetpaytype(data) {

    this.appService.fnSetPayType(data).subscribe(
      (res) => { this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The paytype has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.paytypeid, data.paytypename);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/PayType']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    this.paytypeform.setValue({
      paytypeid: deptBO.paytypeid,
      paytypename: deptBO.paytypename,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch{

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }










}
